/* Display estimates only. Never changes Shopify cart data or Stripe amounts. */
(() => {
  const panel = document.getElementById('local-currency');
  if (!panel) return;
  const select = panel.querySelector('select');
  const regions = [...document.querySelectorAll('[data-region-currency]')];
  const flag = code => /^[A-Z]{2}$/.test(code) ? [...code].map(c => String.fromCodePoint(c.charCodeAt(0) + 127397)).join('') : '🌍';
  regions.forEach(region => {
    [...region.options].forEach(option => { option.dataset.countryName = option.textContent.trim(); });
    const icon = region.closest('form').querySelector('[data-region-flag]');
    if (icon) icon.textContent = flag(region.value);
  });
  const notice = panel.querySelector('[data-currency-notice]');
  let country = panel.dataset.country;
  const map = {US:'USD',CA:'CAD',AU:'AUD',NZ:'NZD',GB:'GBP',JP:'JPY',IN:'INR',PK:'PKR',AE:'AED',SA:'SAR',SG:'SGD',CH:'CHF',CN:'CNY',HK:'HKD',NO:'NOK',SE:'SEK',DK:'DKK',PL:'PLN',CZ:'CZK',BR:'BRL',MX:'MXN',ZA:'ZAR',MY:'MYR',PH:'PHP',TH:'THB',ID:'IDR',KR:'KRW',TR:'TRY',BH:'BHD',KW:'KWD',QA:'QAR'};
  'AT BE CY DE EE ES FI FR GR HR IE IT LT LU LV MT NL PT SI SK'.split(' ').forEach(c => { map[c] = 'EUR'; });
  const read = key => { try { return JSON.parse(localStorage.getItem(key)); } catch { return null; } };
  const save = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* Storage can be disabled. */ } };
  const preference = read('goblox-display-currency');
  if (preference?.country && regions.some(region => [...region.options].some(option => option.value === preference.country))) country = preference.country;
  let desired = map[country] || 'USD';
  let rates = {USD:1};
  let currency = 'USD';
  let scheduled = false;
  const render = () => {
    scheduled = false;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency, currencyDisplay:'narrowSymbol'});
    document.querySelectorAll('[data-local-money]').forEach(el => {
      if (el.closest('[data-stripe-page]')) return;
      const cents = Number(el.dataset.localMoney);
      if (!Number.isFinite(cents)) return;
      const text = formatter.format(cents / 100 * rates[currency]);
      if (el.textContent !== text) el.textContent = text;
      el.title = currency === 'USD' ? '' : 'Estimate only. Payment is charged in USD.';
    });
  };
  new MutationObserver(() => { if (!scheduled) { scheduled = true; requestAnimationFrame(render); } }).observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['data-local-money']});
  const choose = value => {
    currency = Number.isFinite(rates[value]) && rates[value] > 0 ? value : 'USD';
    select.value = currency;
    regions.forEach(region => {
      region.value = country;
      const icon = region.closest('form').querySelector('[data-region-flag]');
      if (icon) icon.textContent = flag(country);
      [...region.options].forEach(option => {
        const code = option.value === country ? currency : (rates[map[option.value]] ? map[option.value] : 'USD');
        const label = `${flag(option.value)} ${option.dataset.countryName} · ${code}`;
        if (option.textContent !== label) option.textContent = label;
      });
    });
    notice.textContent = currency === 'USD' ? 'Payment is charged in USD.' : `Prices in ${currency} are estimates. Payment is charged in USD.`;
    render();
  };
  select.addEventListener('change', () => { desired = select.value; save('goblox-display-currency', {country, currency:desired}); choose(desired); });
  // This selector controls display estimates, not Shopify Markets or payment country.
  // Do not POST /localization: it redirects away and can fail in theme preview.
  regions.forEach(region => {
    region.addEventListener('change', event => {
      event.stopImmediatePropagation();
      country = region.value;
      desired = map[country] || 'USD';
      save('goblox-display-currency', {country, currency:desired});
      choose(desired);
    }, true);
  });
  const install = data => {
    if (data.base !== 'USD' || !data.rates) throw new Error('Invalid exchange rates');
    rates = {USD:1};
    Object.entries(data.rates).forEach(([code, rate]) => { if (/^[A-Z]{3}$/.test(code) && Number.isFinite(rate) && rate > 0) rates[code] = rate; });
    Object.keys(rates).sort().forEach(code => { if (code !== 'USD') select.add(new Option(code, code)); });
    choose(desired);
  };
  render();
  const cache = read('goblox-fx-usd-v1');
  if (cache && Date.now() - cache.saved < 86400000 && Date.now() >= cache.saved) {
    try { install(cache.data); return; } catch { /* Fetch a fresh valid response. */ }
  }
  fetch('https://api.frankfurter.dev/v1/latest?base=USD', {credentials:'omit', referrerPolicy:'no-referrer', signal:AbortSignal.timeout(6000)})
    .then(r => { if (!r.ok) throw new Error('Rates unavailable'); return r.json(); })
    .then(data => { install(data); save('goblox-fx-usd-v1', {saved:Date.now(),data}); })
    .catch(() => { choose('USD'); notice.textContent = 'Local estimates unavailable. Prices and payment are in USD.'; });
})();
